<form novalidate [formGroup]="groupNameForm" (keydown.enter)="$event.preventDefault()" class="groupname-form">
  <div class="groupname-modal-body">
    <h4>Group Name</h4>
    <mat-form-field appearance="fill" style="width: 100%">
      <mat-label>Group Name</mat-label>
      <input matInput formControlName="reportGroupName" [matAutocomplete]="autoGroup" #groupNameInput>
      <mat-autocomplete #autoGroup="matAutocomplete">
        <mat-option *ngFor="let name of filteredGroupNames" [value]="name">{{ name }}</mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div class="groupname-modal-footer">
    <button mat-button class="btn-flat" (click)="updateGroupName()" type="submit">Change</button>
    <button mat-button class="btn-flat" type="button" (click)="cancelGroupName()">Cancel</button>
  </div>
</form>
